export const Size = {
  Smallest: 'xs',
  Smaller: 'xs',
  Small: 'sm',
  Medium: 'md',
  Large: 'lg',
  Larger: 'xl',
  Largest: '2xl',
} as const;

export type Size = (typeof Size)[keyof typeof Size];
